import {ResponsiveService} from './../../../../../../core/services/responsive.service';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {DocumentTypeService} from '../../../../../../core/services/document-type.service';
import {UserService} from '../../../../../../core/services/user.service';
import {DocumentService} from '../../../../../../core/services/document.service';
import {DocumentPrefillService} from '../../../../../../core/services/document-prefill.service';
import {MatDialog} from '@angular/material/dialog';
import {NotificationService} from '../../../../../../core/services/notification.service';
import {CommonService} from '../../../../../../core/services/common.service';
import {Message} from '../../../../../../core/class/message';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute, Router} from '@angular/router';
import {BranchService} from 'src/app/core/services/branch.service';
import {MatSort, Sort} from '@angular/material/sort';
import { NgForm} from '@angular/forms';
import {MatSelect} from '@angular/material';
import {BehaviorSubject, merge, Observable, of, ReplaySubject, Subject, Subscription} from 'rxjs';
import {CdkDetailRowDirective} from 'src/app/shared/directive/cdk-detail-row.directive';
import {tap, take, map, catchError, filter, switchMap} from 'rxjs/operators';
import {WarningComponent} from '../../../../../../shared/components/warning/warning.component';
import {DataSource, SelectionModel} from '@angular/cdk/collections';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {BaseComponent} from '../../../../../../shared/components/base/base.component';
import {EnumColumnTable, EnumContractStatus, EnumContractUserRole} from 'src/app/core/constants/contract';
import {WarningSmsContractService} from 'src/app/core/services/warning-sms-contract.service';
import {ErrorCode} from '../../../../../../core/constants/error-code';
import {SCREEN_SIZE} from 'src/app/core/constants/screen-size';
import {ForwardContractDialogComponent} from '../forward-contract-dialog/forward-contract-dialog.component';
import {MultiDownloadService} from '../../../../../../core/services/multi-download.service';
import {EnumDownloadMenuName} from '../../../../../../core/constants/common';

@Component({
  selector: 'app-search-document-mine-receive',
  templateUrl: './search-document-mine-receive.component.html',
  styleUrls: ['./search-document-mine-receive.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('void', style({height: '0px', minHeight: '0', visibility: 'hidden'})),
      state('*', style({height: '*', visibility: 'visible'})),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class SearchDocumentMineReceiveComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  /**
   * Check status of document for process update
   */
  checkUpdateDocument = false;
  public warningContractQuantity = false;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  isDisableNamePhoneEmail = true;
  documentTypeEnterprise = {
    documentTypeId: 0,
    name: '',
    parentId: null,
    serviceTypeId: null
  };
  documentEnterprise = {
    documentId: 0,
    name: '',
    parentId: null,
    id: null
  };
  selection = new SelectionModel<string>(true, []);
  displayedColumns: string[] = [];
  columnDefinitions = [
    {def: 'select', default: true , showXS: true, showSM: true, showMD: true, name: '', check: true},
    {def: 'STT', default: true , showXS: true, showSM: true, showMD: true, name: '', check: true},
    {def: 'name', default: true , showXS: true, showSM: true, showMD: true, name: '', check: true},
    {def: 'allName', default: true , showXS: false, showSM: false, showMD: true, name: 'headertable.contract_parties', check: true},
    {def: 'allEmail', default: true , showXS: false, showSM: false, showMD: true, name: 'headertable.contract_parties_email', check: true},
    {def: 'serviceTypeName', default: true , showXS: false, showSM: false, showMD: true, name: 'form.service_type', check: true},
    {def: 'receivedTime', default: true , showXS: false, showSM: false, showMD: true, name: 'enterprise_contract.table_headers.received_date', check: true},
    {def: 'senderName', default: true , showXS: false, showSM: false, showMD: true, name: 'enterprise_contract.table_headers.sender_name', check: true},
    {def: 'createdBy', default: false , showXS: false, showSM: false, showMD: true, name: 'enterprise_contract.table_headers.created_by', check: false},
    {def: 'status', default: false , showXS: false, showSM: false, showMD: true, name: 'enterprise_contract.table_headers.document_status', check: false},
    {def: 'expiredDate', default: false , showXS: false, showSM: true, showMD: true, name: 'enterprise-certificate_management.lbl_end_date', check: false},
    {def: 'formType', default: false , showXS: false, showSM: false, showMD: true, name: 'contract_terminate.form_type', check: false},
    {def: 'action', default: true , showXS: true, showSM: true, showMD: true, name: '', check: true}
  ];
  tableWidth = 950;
  isCheckedAllColumn: boolean = false;
  showColumnSelection = false;
  selectedColumn: string;
  enumContractStatus = EnumContractStatus;
  isNotAttestedUser: boolean = false;

  documents = new Document();
  enumContractUserRole = EnumContractUserRole;
  enumColumnTable = EnumColumnTable;
  checkFocus = true;
  dataSource: DocumentDataSource;
  childDataSourceList: DocumentTypeDataSourceKeyPair = {};
  paginate: Paginate;
  oldData = this.documents;
  isFirstLoad = true;
  isTableLoading = false;
  // Plan A: list API chi duoc goi sau khi API cau hinh cot (user-config) da tra ve
  // signal bat = true sau khi getColumnByUser() da ap config + getDisplayedColumns()
  private columnConfigLoaded$ = new BehaviorSubject<boolean>(false);
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  @ViewChild('myForm', {static: false}) ngForm: NgForm;
  @ViewChildren('focusInput') focusInput;
  @ViewChild('signRoleSelect', {static: false}) signRoleSelect: MatSelect;
  sortDirection = 'ASC';
  sortColumn = 'name';
  error = '';
  subscription: Subscription;
  expanded = [];
  openedRow: CdkDetailRowDirective;
  parentDocuments: Document[];
  isDocumentManager: boolean;
  enterpriseId: string;
  // Selected model value for autocomplete
  selectedBranch: { id: string, name: '' };
  // List all parent branches
  public filteredDocumentTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);

  // List all parent branches
  // parentBranches: { id: string, name: '' }[];
  isBasicSearchForm = true;
  createdDateErr = '';
  finishedDateErr = '';
  @Input() singleChildRowDetail: boolean;
  private EventWarningContractSubscription: Subscription;
  private dialogRef: any;
  private onDestroySubject = new Subject<void>();

  constructor(
    private documentTypeService: DocumentTypeService,
    private usService: UserService,
    private documentService: DocumentService,
    private documentPrefillService: DocumentPrefillService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    public commonService: CommonService,
    public message: Message,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private branchService: BranchService,
    private changeDetectorRefs: ChangeDetectorRef,
    private warningSmsContractService: WarningSmsContractService,
    private responsiveService: ResponsiveService,
    private downloadService: MultiDownloadService,
  ) {
    super(commonService, message);
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
  }

  isExpansionDetailRow = (index, row) => row.hasOwnProperty('detailRow');

  ngOnInit() {
    this.getColumnByUser().subscribe();
    this.isDocumentManager = true;
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.dataSource = new DocumentDataSource();
    this.loadData();
    this.notificationService.subscribeErrorService();
    // reset errorCode
    this.notificationService.resetErrorCode();
    // subscribe errorCode
    this.notificationService.getErrorCode().subscribe(errorCode => {
      if (errorCode === ErrorCode.NoAccessToContracts) {
        if (this.dialogRef) {
          this.dialogRef.close();
        }
        this.toastr.error(this.message.getMessage('messages.contract_processed'));
        this.loadData();
      }
      if (errorCode === ErrorCode.ContractProcessed) {
        if (this.dialogRef) {
          this.dialogRef.close();
        }
        this.loadData();
      }
    });

    window.scrollTo(0, 0);
    this.warningSmsContractService.getDataQuantityAndWarningQuantitySmsContractOfEnterpriseByService();
    this.EventWarningContractSubscription = this.warningSmsContractService.statusUpdated.subscribe(
      (result) => {
        this.warningContractQuantity = result;
      }
    );
  }

  getColumnByUser(): Observable<boolean> {
    return this.documentService.getColumnDynamic('CREATE_MY_RECEIVE_DOCUMENT').pipe(
      take(1),
      catchError(() => of(false)),
      tap(rs => {
        if (rs && rs.success) {
          if (rs.data) {
            const check = JSON.parse(rs.data);
            const recordsWithDefaultTrue = check.find(item => item.default === false);
            if (recordsWithDefaultTrue) {
              this.isCheckedAllColumn = false;
            } else {
              this.isCheckedAllColumn = true;
            }
            this.columnDefinitions = this.columnDefinitions.map(ele => {
              const checkDef = check.find(item => item.def === ele.def);
              return checkDef ? {...ele, default: checkDef.default} : ele;
            });
          }
        } else if (rs && !rs.success) {
          this.toastr.error(this.message.getMessage('messages.update_certificate_renew_server_error'));
        }
        // chi ap config va mo khoa list API; getDisplayedColumns() chay trong callback list
        // cung tick voi data -> header + data render cung 1 lan, khong trang thai trung gian
        this.columnConfigLoaded$.next(true);
      }),
      map(() => true)
    );
  }

  onCheckboxChange(column: any) {
    const recordsWithDefaultTrue = this.columnDefinitions.find(item => item.default === false);
    if (recordsWithDefaultTrue) {
      this.isCheckedAllColumn = false ;
    } else {
      this.isCheckedAllColumn = true ;
    }
    this.getDisplayedColumns();
    this.changeWidthTable();
    const codeColumnByUser = {
      code: "CREATE_MY_RECEIVE_DOCUMENT",
      value: JSON.stringify(this.columnDefinitions.map(item => ({
        def: item.def,
        default: item.default
      })))
    };
    this.documentService.saveColumnDynamic(codeColumnByUser)
      .subscribe(res => {
      });
  }

  onAllColumnCheckboxChange(isCheck: any) {
    if (isCheck) {
      this.columnDefinitions.forEach((column) => {
        column.default = true;
      });
    } else {
      this.columnDefinitions.forEach((column) => {
        if (!column.check) {
          column.default = false;
        }
      });
    }
    this.getDisplayedColumns();
    this.changeWidthTable();
    const codeColumnByUser = {
      code: "CREATE_MY_RECEIVE_DOCUMENT",
      value: JSON.stringify(this.columnDefinitions.map(item => ({
        def: item.def,
        default: item.default
      })))
    };
    this.documentService.saveColumnDynamic(codeColumnByUser)
      .subscribe(res => {
      });
  }

  changeWidthTable() {
    const check = this.columnDefinitions.filter(item => item.default === true);
    if (this.mediaBreakpoint === SCREEN_SIZE.MD ) {
      this.tableWidth = 1650 ;
    } else {
      if (check.length > 9) {
        this.tableWidth = 1650;
      } else if (check.length <= 9) {
        this.tableWidth = 950;
      }
    }
  }


  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showXS)
        .map(cd => cd.def);
      this.tableWidth = 300 ;
    } else {
      if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
        this.displayedColumns = this.columnDefinitions
          .filter(cd => cd.showMD  && cd.default)
          .map(cd => cd.def);
      } else {
        this.displayedColumns = this.columnDefinitions.filter(cd => cd.default).map(cd => cd.def );
      }
      this.changeWidthTable();
    }
  }

  ngAfterViewInit(page: number = 0) {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    merge(this.sort.sortChange, page)
      .pipe(
        tap(() => this.onFilterData(this.paginate.currentPage, this.paginate.pageSize))
      )
      .subscribe();

    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.EventWarningContractSubscription.unsubscribe();
    this.subscribeMediaBreakPointService.unsubscribe();
    this.downloadService.clearData();
  }

  getFilterCondition(page: number, pageSize: number, data: any): any {
    const {
      customerName,
      nameOrCode,
      receivedTimeFrom,
      receivedTimeTo,
      signRole,
      nameOrEmailOrPhoneUserSign,
      senderName,
    } = data;
    let filterCondition: any = {
      nameOrCode,
      senderName,
      customer: customerName,
      page,
      pageSize,
    };


    if (!this.isBasicSearchForm) {
      filterCondition = {
        ...filterCondition,
        receivedTimeFrom,
        receivedTimeTo,
        signRole: signRole,
        nameOrEmailOrPhoneUserSign: nameOrEmailOrPhoneUserSign,
      };
    }

    let sortColumn = null;
    let sortDirection = null;

    sortDirection = this.sortDirection;
    sortColumn = this.sortColumn; // is searching in parent

    let column = null;
    switch (sortColumn) {
      case 'name':
        column = {
          contractName: sortDirection
        };
        break;
      case 'receivedTime':
        column = {
          receivedTime: sortDirection
        };
        break;
    }

    filterCondition.sorts = column;

    // console.log("filterCondition", filterCondition);
    return filterCondition;
  }

  onToggleChange(cdkDetailRow: CdkDetailRowDirective, row): void {
    if (this.singleChildRowDetail && this.openedRow && this.openedRow.expended) {
      this.openedRow.toggle();
    }

    if (!row.close) {
      row.close = true;
    } else {
      row.close = false;
    }
    this.openedRow = cdkDetailRow.expended ? cdkDetailRow : undefined;
  }

  /**
   * Count record to show
   */
  counter(index: number, from: number): any {
    return new Array(index).fill(0).map((x, i) => i + from);
  }

  /**
   * Get data when init
   */
  loadData(page: number = 0, pageSize: number = 10) {
    let paramNameOrCode: '';
    let paramCustomerName: '';
    let paramReceivedTimeFrom: any;
    let paramReceivedTimeTo: any;
    let paramSignRole: any;
    let paramNameOrEmailOrPhoneUserSign: '';
    let paramSenderName: '';

    this.subscription = this.route
      .queryParams
      .subscribe(params => {
        paramNameOrCode = params.nameOrCode;
        paramCustomerName = params.customerName;
        paramSenderName = params.senderName;
        paramSignRole = parseInt(params.signRole) || null;
        paramNameOrEmailOrPhoneUserSign = params.nameOrEmailOrPhoneUserSign;
        paramReceivedTimeFrom = params.receivedTimeFrom != null ? new Date(params.receivedTimeFrom) : null;
        paramReceivedTimeTo = params.receivedTimeTo != null ? new Date(params.receivedTimeTo) : null;
        page = params.page || 0;
        pageSize = params.pageSize && params.pageSize > 0 ? params.pageSize : 10;
        this.sortColumn = params.sortColumn != null ? params.sortColumn : null;
        this.sortDirection = params.sortDirection != null ? params.sortDirection : null;
      });

    this.documents.nameOrCode = paramNameOrCode;
    this.documents.customerName = paramCustomerName;
    this.documents.senderName = paramSenderName;
    this.documents.receivedTimeFrom = paramReceivedTimeFrom;
    this.documents.receivedTimeTo = paramReceivedTimeTo;
    this.documents.signRole = paramSignRole ? Number(paramSignRole) : null;
    this.documents.nameOrEmailOrPhoneUserSign = paramNameOrEmailOrPhoneUserSign;

    if ((paramSignRole && paramSignRole !== 'null') || paramNameOrEmailOrPhoneUserSign || paramReceivedTimeFrom || paramReceivedTimeTo) {
      this.isBasicSearchForm = false;
    } else {
      this.isBasicSearchForm = true;
    }

    // if (this.parentBranches) {
    //   this.selectedBranch = this.parentBranches.find(x => {
    //     return x.id === paramEnterprise;
    //   });
    // }

    // DESC or ASC
    if (this.isFirstLoad === false) {
      if (this.sort.direction === 'asc') {
        this.sortDirection = 'ASC';
      } else if (this.sort.direction === 'desc') {
        this.sortDirection = 'DESC';
      }
    } else {
      this.isFirstLoad = false;
    }

    this.isTableLoading = true;
    // clear data cu: skeleton la footer-row nam duoi cung bang, neu giu data cu thi no nam
    // duoi man hinh -> clear de skeleton hien ngay duoi header nhu luc vua vao trang
    this.dataSource.setData([]);
    // Plan A: cho config cot tra ve roi moi goi list -> data luon render dung theo cot da cap nhat
    this.columnConfigLoaded$.pipe(
      filter(loaded => loaded),
      take(1),
      switchMap(() => this.documentService.searchMyReceiveContract(this.getFilterCondition(page, pageSize, this.documents)))
    )
    .subscribe(rs => {
      // doi header theo config BE; CD tick chay ngay sau callback se re-render header theo cot moi
      this.getDisplayedColumns();
      if (rs.data != null && rs.data.currentPage != null && rs.data.pageSize != null
        && rs.data.totalRow != null) {
        this.paginate = {
          currentPage: rs.data.currentPage,
          pageSize: rs.data.pageSize,
          totalRow: rs.data.totalRow,
          totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
          totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
          no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
        };
      }

      // data render trong macrotask sau CD tick -> rowDef.columns da cap nhat xong,
      // row luon dung theo cot config; an skeleton cung luc de header + data len cung thoi diem
      setTimeout(() => {
        this.isTableLoading = false;
        if (rs.data && rs.data.dataRow != null) {
          this.initParent(rs);
        }
      });
    }, () => this.isTableLoading = false);
  }

  /**
   * Get inform of branch
   */
  getBranch(branchId: number) {
    this.branchService.getBranch(branchId).subscribe(
      rs => {
        this.selectedBranch = {
          id: String(branchId),
          name: rs.data.name
        };
      }
    );
  }

  initParent(rs: any): void {
    let stt = this.paginate.pageSize * this.paginate.currentPage + 1;

    this.parentDocuments = rs.data.dataRow;
    rs.data.dataRow.forEach(el => {
      el.STT = stt++;
    });
    this.dataSource.setData(this.parentDocuments);
  }

  sortData(sort: Sort) {

    if (!sort.active || sort.direction === '') {
      return;
    }

    this.sortColumn = sort.active;
  }

  /**
   * Filter data with condition
   */
  onFilterData(page: number = 0, pageSize: number = 10) {
    if (this.isFirstLoad === false) {
      if (this.sort.direction === 'asc') {
        this.sortDirection = 'ASC';
      } else if (this.sort.direction === 'desc') {
        this.sortDirection = 'DESC';
      }
    } else {
      this.isFirstLoad = false;
    }
    // set null for document model
    this.oldData.nameOrCode = this.oldData.nameOrCode || null;
    this.oldData.customerName = this.oldData.customerName || null;
    this.oldData.receivedTimeFrom = this.oldData.receivedTimeFrom || null;
    this.oldData.receivedTimeTo = this.oldData.receivedTimeTo || null;
    this.oldData.nameOrEmailOrPhoneUserSign = this.oldData.nameOrEmailOrPhoneUserSign || null;
    this.oldData.signRole = this.oldData.signRole || null;
    this.oldData.senderName = this.oldData.senderName || null;

    this.isTableLoading = true;
    // clear data cu de skeleton hien ngay duoi header
    this.dataSource.setData([]);
    // Plan A: cho config cot tra ve roi moi goi list (lan dau; cac lan filter sau signal da bat)
    this.columnConfigLoaded$.pipe(
      filter(loaded => loaded),
      take(1),
      switchMap(() => this.documentService.searchMyReceiveContract(this.getFilterCondition(page, pageSize, this.oldData)))
    )
    .subscribe(
      rs => {
        // doi header theo config BE; CD tick chay ngay sau callback se re-render header theo cot moi
        this.getDisplayedColumns();
        this.paginate = {
          currentPage: rs.data.currentPage,
          pageSize: rs.data.pageSize,
          totalRow: rs.data.totalRow,
          totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
          totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
          no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
        };

        // data render trong macrotask sau CD tick -> rowDef.columns da cap nhat xong,
        // row luon dung theo cot config; an skeleton cung luc de header + data len cung thoi diem
        setTimeout(() => {
          this.isTableLoading = false;
          this.initParent(rs);

          if (this.isBasicSearchForm) {
            this.documents.receivedTimeFrom = null;
            this.documents.receivedTimeTo = null;
            this.documents.signRole = null;
            this.documents.nameOrEmailOrPhoneUserSign = '';
          }
        });
      }
      , () => this.isTableLoading = false
    );
  }

  /**
   * Delete document
   * xóa
   */
  delete(id: any, parentId: string = null, documentName: string) {
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '500px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_delete_docs'), documentName)
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.documentService.delete(id).subscribe(() => {
          this.toastr.success(this.message.getMessage('messages.delete_success'));
          if (this.paginate.totalRow % this.paginate.pageSize === 1) {
            if (this.paginate.currentPage - 1 < 0) {
              this.paginate.currentPage = 0;
            } else {
              this.paginate.currentPage = this.paginate.currentPage - 1;
            }
          }
          // is parent element
          this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
        });
      }
    });
  }

  /**
   * Chuyển tiếp HĐ
   * Forward Contract
   */

  forwardContract(element) {
    const dialogRe = this.dialog.open(ForwardContractDialogComponent, {
      width: '700px',
      data: {data: element},
    });
    dialogRe.afterClosed().subscribe(rs => {
      if (rs) {
        this.toastr.success(this.message.getMessage('messages.notify_sign_contract_user_success'));
      }
    });
  }

  /**
   * Navigate to view detail document
   */
  viewDetail(id, type?, element?) {
    // truyen row bang cho man view-document hien thong tin co ban ngay, khong cho API detail
    if (element) {
      this.documentPrefillService.setPrefill(id, element);
    }
    if (type) {
      this.toNavigate('/home-enterprise/view-document/' + id, {goFrom: 'mineReceive', typeCopy: type});
    } else {
      this.toNavigate('/home-enterprise/view-document/' + id, {goFrom: 'mineReceive'});
    }
  }

  /**
   * Open PDF By Browser
   */
  openPDFByBrowser(documentData: any) {
    if (documentData.id) {
      this.documentService.downloadFileZip(documentData.id).subscribe(res => {
        const blobUrl = URL.createObjectURL(res);
        var a = document.createElement('a');
        a.href = blobUrl;
        a.download = documentData.name + '.zip';
        a.click();
      });
    }
  }


  multiDownload() {
    this.downloadService.setData({
      contractIds: this.selection.selected,
      menuContract: EnumDownloadMenuName.SEARCH_DOCUMENT_MINE_RECEIVE,
    });
  }

  onClickBtnFilter() {
    this.oldData = this.documents;
    if (!((this.documents.signRole == null || this.documents.signRole == 'null') || this.documents.nameOrEmailOrPhoneUserSign == null) && !this.isBasicSearchForm) {
      if (this.columnDefinitions.length < 13) {
        const action = this.columnDefinitions.pop();
        this.columnDefinitions.push(
          {def: 'userSign', default: true, showXS: false, showSM: false, showMD: false, name: '', check: true}
        );
        this.columnDefinitions.push(
          {def: 'role', default: true, showXS: false, showSM: false, showMD: false, name: '', check: true}
        );
        this.columnDefinitions.push(action);
        this.getDisplayedColumns();
      }

    } else {
      if (this.columnDefinitions.length > 13) {
        const action = this.columnDefinitions.pop();
        this.columnDefinitions.pop();
        this.columnDefinitions.pop();
        this.columnDefinitions.push(action);
        this.getDisplayedColumns();
      }
    }
  }

  signRoleChanged(data: any) {
    if (this.documents.signRole === null || this.documents.signRole === 'null') {
      this.documents.nameOrEmailOrPhoneUserSign = null;
      this.documents.signRole = null;
      this.isDisableNamePhoneEmail = true;
    } else {
      this.isDisableNamePhoneEmail = false;
    }
    this.ngForm.control.markAllAsTouched();
  }

  /**
   * Open advanced search form
   */
  onExpandAdvancedSearchForm() {
    this.isBasicSearchForm = false;
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  /**
   * Close advanced search form
   */
  onCloseAdvancedSearchForm() {
    this.isBasicSearchForm = true;
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  /**
   * Set params for to navigate
   */
  toNavigate(route, params = {}) {
    let queryParams: any = {
      ...params,
      page: this.paginate.currentPage,
      pageSize: this.paginate.pageSize,
      routeLink: '/home-enterprise/search-my-receive-document/',
      nameOrCode: this.documents.nameOrCode,
      customerName: this.documents.customerName,
      senderName: this.documents.senderName,
      sortColumn: this.sortColumn,
      sortDirection: this.sortDirection
    };

    if (!this.isBasicSearchForm) {
      queryParams = {
        ...queryParams,
        receivedTimeFrom: this.documents.receivedTimeFrom,
        receivedTimeTo: this.documents.receivedTimeTo,
        signRole: this.documents.signRole,
        nameOrEmailOrPhoneUserSign: this.documents.nameOrEmailOrPhoneUserSign
      };
    }

    this.router.navigate([route], {queryParams});
  }

  /**
   * selected equal data length in page to checkbox all is selected
   */
  isAllSelected() {
    const selecteds = this.selection.selected;
    const dataSourceIds = this.dataSource.data.value.map(d => d.id);
    const intersectionArr = dataSourceIds.filter(data => selecteds.includes(data));
    return intersectionArr.length === dataSourceIds.length;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    const dataSourceIds = this.dataSource.data.value.map(ds => ds.id);
    this.isAllSelected() ?
      this.selection.deselect(...dataSourceIds) :
      this.selection.select(...dataSourceIds);
  }

  getFormType(formType: string){
    if(formType == 'CONTRACT'){
      return this.message.getMessage('contract_terminate.contract')
    } else if (formType == 'CONTRACT_TERMINATION') {
      return this.message.getMessage('contract_terminate.terminate')
    } else if (formType === 'CONTRACT_APPENDIX') {
      return this.message.getMessage('add_document_moha.employment_contract_addendum')
    }  
    else {
      return ''
    }
  }
}

export class Paginate {
  currentPage: number;
  pageSize: number;
  totalRow: number;
  totalPage: number;
  totalPageArray: [];
  no: [];
}

export class Document {
  id: string;
  receivedTimeFrom: string;
  receivedTimeTo: string;
  customerName: string;
  nameOrCode: string;
  signRole: any;
  nameOrEmailOrPhoneUserSign: string;
  senderName: string;
}

export class DocumentTypeDataSourceKeyPair {
  [key: string]: DocumentDataSource;
}

export class PaginateKeyPair {
  [key: string]: Paginate;
}

export class DocumentDataSource extends DataSource<Document> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<Document[]>([]);

  constructor() {
    super();
  }


  setData(data: Document[]) {
    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Document[]> {
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
  }
}
